
export const isTimeInRange = (startHour, startMinute, endHour, endMinute) => {
    const now = new Date();
    const start = new Date();
    const end = new Date();
  
    start.setHours(startHour, startMinute, 0, 0);
    end.setHours(endHour, endMinute, 0, 0);
  
    return now >= start && now <= end;
  };